import { apiRequest } from "./client";

export type DispatchStatus = "active" | "disabled" | "expired";

export interface Dispatch {
  id: string;
  short_token: string;
  document_id: string;
  // JOIN-обогащение из list-эндпоинта; для одиночных ручек бэк отдаёт null.
  document_title?: string | null;
  manager_user_id: string;
  manager_email?: string | null;
  recipient_email: string | null;
  email_subject: string | null;
  access_level: number;
  expires_at: string | null;
  is_disabled: boolean;
  bitrix_notification_sent: boolean;
  created_at: string;
  viewer_url: string;
}

export interface DispatchListResponse {
  items: Dispatch[];
  total_count: number;
}

export interface DispatchListQuery {
  page?: number;
  size?: number;
  manager_user_id?: string;
  document_id?: string;
  is_disabled?: boolean;
  recipient_q?: string;
  status?: DispatchStatus;
}

function buildQuery(query: DispatchListQuery): string {
  const params = new URLSearchParams();
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  if (query.manager_user_id)
    params.set("manager_user_id", query.manager_user_id);
  if (query.document_id) params.set("document_id", query.document_id);
  if (query.is_disabled !== undefined)
    params.set("is_disabled", String(query.is_disabled));
  if (query.recipient_q) params.set("recipient_q", query.recipient_q);
  if (query.status) params.set("status", query.status);
  const s = params.toString();
  return s ? `?${s}` : "";
}

export const dispatchesApi = {
  list: (query: DispatchListQuery = {}) =>
    apiRequest<DispatchListResponse>(`/dispatches${buildQuery(query)}`),
  get: (id: string) => apiRequest<Dispatch>(`/dispatches/${id}`),
  disable: (id: string) =>
    apiRequest<Dispatch>(`/dispatches/${id}/disable`, {
      method: "POST",
      body: {},
    }),
  enable: (id: string) =>
    apiRequest<Dispatch>(`/dispatches/${id}/enable`, {
      method: "POST",
      body: {},
    }),
  // ttl_days=null отправляем явно: на бэке это «снять срок» (бессрочная
  // ссылка), и мы НЕ хотим, чтобы дефолт схемы (30 дней) случайно выбрал
  // другое значение.
  extend: (id: string, ttl_days: number | null) =>
    apiRequest<Dispatch>(`/dispatches/${id}/extend`, {
      method: "POST",
      body: { ttl_days },
    }),
  reassignManager: (id: string, manager_user_id: string) =>
    apiRequest<Dispatch>(`/dispatches/${id}/reassign-manager`, {
      method: "POST",
      body: { manager_user_id },
    }),
};
